import fetch from 'auth/FetchInterceptor';

const UploadFileService = {};

const api = 'filemanager';

UploadFileService.post = function (data) {
  return fetch({
    url: `${api}/images/upload`,
    method: 'POST',
    data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};

UploadFileService.validURL = (str) => {
  var pattern = new RegExp(
    '^(https?:\\/\\/)?' + // protocol
    '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
    '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
    '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
    '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
    '(\\#[-a-z\\d_]*)?$',
    'i'
  ); // fragment locator
  return !!pattern.test(str);
};

const uploadImages = async (data) => {
  try {
    const res = await fetch({
      url: `${api}/images/upload`,
      method: 'POST',
      data,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return res.imageUrls;
  } catch (err) {
    console.log(err, 'show-err');
  }
};

UploadFileService.getImageUrl = async (file, category = 'general') => {
  const formData = new FormData();
  formData.append('files', file);
  const urls = await uploadImages(formData);

  if (urls) {
    return urls[0];
  }

  return '';
};

UploadFileService.postWithoutWaterMark = function (data) {
  return fetch({
    url: `${api}/images/upload_without_watermark`,
    method: 'POST',
    data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};

UploadFileService.postVideo = function (data) {
  return fetch({
    url: `${api}/video/upload`,
    method: 'POST',
    data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};

UploadFileService.postPdf = function (data) {
  return fetch({
    url: `${api}/pdf/upload`,
    method: 'POST',
    data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};

export default UploadFileService;
